import AttackChains from "../AttackSimulation/AttackChains"

import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"
import { useTicketing } from "@/organisms/Ticketing/hooks/useTicketing"

export const AttackSimulationTab = (props: TabComponentProps) => {
  const { systems } = useTicketing()
  const hasIntegration = systems.length > 0

  return <AttackChains hasIntegration={hasIntegration} {...props} />
}
